module.exports = __webpack_public_path__ + "media/images/cplook/apple-touch-icon-180x180-32198da328fb02564a7cdf8281aeaf9f.png";